import { TFunction } from 'i18next'
import { StringSchema, string } from 'yup'

import { nonEmptyStringSchema, stringSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const rEmail =
  // eslint-disable-next-line
  /^((([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/

export const emailSchema = (
  t: TFunction<'translation', undefined>,
  isRequired = true,
): StringSchema<string | undefined> => {
  const schema = isRequired ? nonEmptyStringSchema(t, 75) : stringSchema(t, 75)
  const rEmail =
    // eslint-disable-next-line
    /^((([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/

  const matched = schema
    .test('ascii-domain', t(formTranslation.errors.noValidFormat), (value) => {
      if (!value) return true
      const v = String(value)
      const parts = v.split('@')
      if (parts.length !== 2) return false
      const domain = parts[1].toLowerCase()
      for (let i = 0; i < domain.length; i++) {
        if (domain.charCodeAt(i) > 127) return false
      }
      if (domain.split('.').some(l => l.startsWith('xn--'))) return false
      return true
    })
    .matches(rEmail, { message: t(formTranslation.errors.noValidFormat), excludeEmptyString: true })

  return isRequired ? matched.required(t(formTranslation.errors.fieldRequired)) : matched
}

export const emailSchemaStep2 = (
  t: TFunction<'translation', undefined>,
  isRequired = true,
): StringSchema<string | undefined> => {
  const schema = isRequired ? nonEmptyStringSchema(t, 75) : stringSchema(t, 75)

  return schema
    .test(
      'no-disallowed-chars',
      t(formTranslation.errors.invalidFormat),
      (value) => {
        if (!value) return true;
        const hasOnlyAllowedChars = /^[a-zA-Z0-9@._-]*$/.test(value);
        return hasOnlyAllowedChars;
      }
    )
    .matches(
      rEmail,
      t(formTranslation.errors.invalidFormat)
    );
}

export const emailSchemaHelpCenter = (
  t: TFunction<'translation', undefined>,
  isRequired = true,
): StringSchema<string | undefined> => {
  const schema = string()
    .defined()
    .typeError(t(formTranslation.errors.fieldRequired))
    .max(75, t(formTranslation.errors.maxChars, { value: 75 }))
  const rEmail =
    // eslint-disable-next-line
    /^((([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/

  const matched = schema
    .test('ascii-domain', t(formTranslation.errors.noValidFormat), (value) => {
      if (!value) return true
      const v = String(value)
      const parts = v.split('@')
      if (parts.length !== 2) return false
      const domain = parts[1].toLowerCase()
      for (let i = 0; i < domain.length; i++) {
        if (domain.charCodeAt(i) > 127) return false
      }
      if (domain.split('.').some(l => l.startsWith('xn--'))) return false
      return true
    })
    .matches(rEmail, { message: t(formTranslation.errors.noValidFormat), excludeEmptyString: true })

  return isRequired ? matched.required(t(formTranslation.errors.fieldRequired)) : matched
}
